<div mat-dialog-title>
  <span>{{ 'CORE.IMPACT_ASSESSMENT.ADD_METADATA_TITLE' | translate }}</span>

  <q9-dialog-close-button [disabled]="isSubmitted"></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="warningMessage()" type="error">
  {{ warningMessage() | translate }}
</q9-info-message>

<form class="dialog-form" #form="ngForm">
  <mat-dialog-content>
    <q9-add-metadata-form
      [isAddToStoryClicked]="isAddToStoryClicked"
      [isSubmitted]="isSubmitted"
      (nodeSearchLoaded)="onNodeSearchLoaded($event)"
      (isSelectedFiftyWarning)="setWarningMessage($event)"
      [previewMode]="isPreviewMode()"
      (isSelectedFiftyWarning)="setWarningMessage($event)"
      [formControl]="addMetadataFormControl">
      <q9-textarea-field
        below-preview-list
        [minRows]="3"
        [maxRows]="10"
        label="CORE.ATTACHMENTS.DESCRIPTION_LABEL_LINKS"
        [formControl]="linkDescriptionFormControl"></q9-textarea-field>
    </q9-add-metadata-form>
  </mat-dialog-content>
</form>

<mat-dialog-actions>
  <span class="counter" *ngIf="!isPreviewMode() && metadataList?.length">
    {{
      'CORE.IMPACT_ASSESSMENT.SELECTED_METADATA_COUNT'
        | translate
          : {
              count: metadataList?.length,
              max: MAX_SELECTED_AMOUNT
            }
    }}
  </span>

  <ng-container *ngIf="!isPreviewMode(); else previewButtons">
    <ng-container *ngTemplateOutlet="initialButtons"></ng-container>
  </ng-container>

  <ng-template #initialButtons>
    <q9-secondary-button mat-dialog-close>
      {{ 'CORE.GENERAL.CANCEL_TITLE' | translate }}
    </q9-secondary-button>

    <q9-primary-button (click)="form.onSubmit($event); goToPreviewMode()">
      {{ 'SEARCH_ORG_NODE.ADD_TO_ACTIVITY' | translate }}
    </q9-primary-button>
  </ng-template>

  <ng-template #previewButtons>
    <q9-secondary-button
      [disabled]="isSubmitted"
      (click)="!isSubmitted && isPreviewMode.set(false)">
      {{ 'CORE.GENERAL.BACK' | translate }}
    </q9-secondary-button>

    <q9-secondary-button [disabled]="isSubmitted" (click)="!isSubmitted && dialogRef.close(false)">
      {{ 'CORE.GENERAL.CANCEL_TITLE' | translate }}
    </q9-secondary-button>

    <q9-primary-button [isLoading]="isSubmitted && !error" (click)="!isSubmitted && onSubmit()">
      {{ 'CORE.GENERAL.ATTACH' | translate }}
    </q9-primary-button>
  </ng-template>
</mat-dialog-actions>
